import React, { useState, useEffect } from "react"
import styled from "styled-components"
import MainListTab from "components/containers/main/list/MainListTab"
import CampaignMainList from "components/containers/campaign/list/CampaignMainList"
import MotibellList from "components/modules/motibell/MotibellList"

/**
 * @param type : This is type of main list. (eg. 'normal' or 'company')
 */
export default function MainList({ scrollRef, type, initList }) {
  const [currTab, setCurrTab] = useState("campaign") //campaign or group
  useEffect(() => {
    if (["motibell", "campaign"].includes(initList)) {
      setCurrTab(initList)
    }
  }, [initList])
  return (
    <>
      {/* TODO : 모티벨 출시전 Commant out 해제 */}
      {type !== "company" ? (
        <MainTabWrapper>
          <MainListTab currTab={currTab} setCurrTab={setCurrTab} />
        </MainTabWrapper>
      ) : null}
      {currTab === "motibell" && type !== "company" ? (
        <ListWrapper>
          <MotibellList scrollRef={scrollRef} />
        </ListWrapper>
      ) : (
        <ListWrapper>
          <CampaignMainList scrollRef={scrollRef} type={type} />
        </ListWrapper>
      )}
    </>
  )
}

const MainTabWrapper = styled.div`
  padding: 0 calc(100vw * (25 / 375));
  margin-bottom: calc(100vw * (19 / 375));
`

const ListWrapper = styled.div`
  padding: 0 calc(100vw * (17 / 375));
`

const ChallengeTitleBlock = styled.div`
  padding-left: calc(100vw * (17 / 375));
  margin-bottom: calc(100vw * (20 / 375));
`

const Title = styled.h1`
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (23 / 375));
  color: "#121212";
  font-weight: 700;
`
